/*
*
* 链接常量
* */
let constants = {}
// 微信分享接口
constants.WXSHAREURL = '/wx/mp/wx139a9bf36bf1ee1b/ticket'
// constants.WXSHAREURL = '/mp/ticket/wx139a9bf36bf1ee1b'

// admin获取验证码
constants.GETVCODE_ADMINURL = '/admin/mobile/'
// marketing获取验证码
constants.GETVCODE_MKTURL = '/marketing/getcode'

// marketing获取验证码
constants.GETVCODE_MKTURL_CODE = '/marketing/code'
// 寻车登录验证Url
constants.VC_LOGINURL = '/auth/mobile/token/sms'
// 登录人信息抽取
constants.VC_USERINFOURL = '/admin/user/info'

/* 寻车 微信分享常量 */
constants.VC_SHAREINFO = {
  title: '车家·寻车',
  desc: '互联网寻车，全国寻底价！',
  link: "http://mkt.chejia.net.cn/#/vcar_login",
  imgUrl: 'http://mkt.chejia.net.cn/share/vc_share.jpg'
}

/* 寻车 微信分享常量 */
constants.SS_SHAREINFO = {
  title: '车家Check',
  desc: '查询客户审批信息\r\n获取专项操作指引',
  link: "https://mkt.chejia.net.cn/#/lxcheck",
  imgUrl: 'https://mkt.chejia.net.cn/static/ss_share.jpg'
}

/* Aions促销 微信分享常量 */
constants.AIONS_SHAREINFO = {
  title: '疫情期间车家送您: 全家新冠肺炎保险!',
  desc: '我们不是医生，却也想尽己所能！畅销车型、冰点车价、超低首付、一键开走！',
  link: "http://mkt.chejia.net.cn/#/aions_mar",
  imgUrl: 'http://mkt.chejia.net.cn/share/aions_share.jpg'
}

/* Aions促销 微信分享常量 */
constants.AIONS_GZ_SHAREINFO = {
  title: '3月起购买新能源汽车补贴1万元！',
  desc: '车家再送：全家新冠肺炎保险！畅销车型、冰点车价、超低首付、一键开走！',
  link: "http://mkt.chejia.net.cn/#/aions_gz_mar",
  imgUrl: 'http://mkt.chejia.net.cn/share/aions_share.jpg'
}

/* Aions促销 微信分享常量 */
constants.TESLA_SHAREINFO = {
  title: '预约体验特斯拉!',
  desc: '享品质生活好礼！',
  link: "http://mkt.chejia.net.cn/#/tsl_pro",
  imgUrl: 'http://mkt.chejia.net.cn/share/tesal_share.jpg'
}

/* Aions促销 微信分享常量 */
constants.ZZC_SHAREINFO = {
  title: '预约体验特斯拉!',
  desc: '享品质生活好礼！',
  link: "http://mkt.chejia.net.cn/#/zzc",
  imgUrl: 'http://mkt.chejia.net.cn/share/zzc_share.png'
}
/* 小鹏P7促销 微信分享常量 */
constants.XP_P7_SHAREINFO = {
  title: '车家"鹏"友专项促销',
  desc: `小鹏P7后驱长续航智享版\r\n两年零息 再送交强险`,
  link: "http://mkt.chejia.net.cn/#/cus_collect_p7",
  imgUrl: 'http://mkt.chejia.net.cn/static/xp_p7_share.png'
}
/*  车家·小选  微信分享常量 */
constants.SIMPLESALES = {
  title: '车家·小选',
  desc: '灿谷集团 车家·小选\r\n伙伴限时招募中',
  link: "http://mkt.chejia.net.cn/#/partner",
  imgUrl: 'http://mkt.chejia.net.cn/static/xp_p7_share.png'
}



/* 微信分享常量 */
constants.XP_SHAREINFO_202108 = {
  title: '小鹏P7限时劲爆促销',
  desc: '终身免费充电 原厂八年质保\r\n10%超低首付 全程在线购车\r\n全国包邮到家 提车三天可退',
  link: "http://mkt.chejia.net.cn/#/xp01",
  imgUrl: 'http://mkt.chejia.net.cn/static/xp_share_202108.png'
}
/* 蔚来汽车分享  微信分享常量 */
constants.NIO_SHAREINFO = {
  title: '蔚来汽车劲爆促销',
  desc: 'ES6/EC6享8000元权益\r\n全国统一零售价341800起',
  link: "http://mkt.chejia.net.cn/#/nio",
  imgUrl: 'http://mkt.chejia.net.cn/static/xp_p7_share.png'
}

/* 小鹏P5促销 微信分享常量 */
constants.XP_P5_SHAREINFO = {
  title: '车家"鹏友"专项促销',
  desc: `车家‘鹏友’优先提车\r\n最高享30,000综合购车权益`,
  link: "http://mkt.chejia.net.cn/#/xp2110",
  imgUrl: 'http://mkt.chejia.net.cn/static/xp_p7_share.png'
}



/* 理想汽车江南银行预审批 */
constants.LX_APPLY_SHAREINFO = {
  title: '理想汽车',
  desc: '江南银行预审批',
  link: "https://mkt.chejia.net.cn/#/lxApply",
  imgUrl: 'https://mkt.chejia.net.cn/static/img/share.jpg'
}
export default constants;



// WEBPACK FOOTER //
// ./src/utils/constants.js